import WwwLayout from "./Layout";
import HomePage from "./pages/HomePage";
export const wwwAdapter = {
    siteId: "coremind-site-www",
    version: "0.1.0",
    theme: {},
    layout: WwwLayout,
    metadata: {
        name: "Offsetmind",
        description: "The Offsetmind platform landing page — discover and join platform sites.",
    },
    navigation: { primary: [] },
    routes: [{ path: "/", component: HomePage }],
};
